<dashboardnav>

  <cradua-rackettrayref
  [cabinetshelfrefs]="cabinetshelfrefs$ | async"
  [racktrayrefs]="racktrayrefs$ | async"

  (changeEmit)="onSubmitRackTrayRef($event)"
  (deleteEvent)="onDeleteRackTrayRef($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-rackettrayref>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
